import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  readonly isOnline = signal(navigator.onLine);

  constructor() {
    window.addEventListener('online', () => this.isOnline.set(true));
    window.addEventListener('offline', () => this.isOnline.set(false));
  }

  async check(): Promise<boolean> {
    try {
      await fetch(`favicon.ico?_=${Date.now()}`, {
        method: 'HEAD',
        cache: 'no-store',
      });
      this.isOnline.set(true);
    } catch {
      this.isOnline.set(false);
    }

    return this.isOnline();
  }
}
